import { render, staticRenderFns } from "./upgradeTask.vue?vue&type=template&id=239bb3d8&scoped=true"
import script from "./upgradeTask.vue?vue&type=script&lang=js"
export * from "./upgradeTask.vue?vue&type=script&lang=js"
import style0 from "./upgradeTask.vue?vue&type=style&index=0&id=239bb3d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239bb3d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('239bb3d8')) {
      api.createRecord('239bb3d8', component.options)
    } else {
      api.reload('239bb3d8', component.options)
    }
    module.hot.accept("./upgradeTask.vue?vue&type=template&id=239bb3d8&scoped=true", function () {
      api.rerender('239bb3d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/firmware/taskList/upgradeTask.vue"
export default component.exports